import React, { useState, useEffect } from 'react'

export default function TableOfContents({ contentRef }) {
  const [headings, setHeadings] = useState([])
  const [active,   setActive]   = useState(null)

  useEffect(() => {
    if (!contentRef.current) return
    const els = contentRef.current.querySelectorAll('h2, h3')
    const items = Array.from(els).map((el, i) => {
      const id = `sp-heading-${i}`
      el.id = id
      return { id, text: el.textContent, tag: el.tagName }
    })
    setHeadings(items)

    const obs = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) setActive(e.target.id) }) },
      { rootMargin: '-20% 0% -60% 0%' }
    )
    els.forEach(el => obs.observe(el))
    return () => obs.disconnect()
  }, [contentRef])

  if (!headings.length) return null

  return (
    <nav className="sp-toc">
      <div className="sp-toc__label">Contents</div>
      <ol className="sp-toc__list">
        {headings.map(h => (
          <li key={h.id} className={`sp-toc__item sp-toc__item--${h.tag.toLowerCase()}${active === h.id ? ' sp-toc__item--active' : ''}`}>
            <a href={`#${h.id}`} onClick={e => {
              e.preventDefault()
              document.getElementById(h.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }}>
              {h.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}
